/* eslint-disable */
import axios from 'axios'
import cookie from 'react-cookies'
import {message} from 'antd'
import {baseURL} from '../BaseComponent/configTheme'
import {createAccess, loadAccessToken, loadRefreshToken, removeCookie} from '../Cookie/cookie'

const instance = axios.create({baseURL})
let isRefreshing = false
let refreshSubscribers = []

//comment in

function isExpired(value) {
  return value
}

function resetToken(refreshToken) {
  return axios({
    method: 'get',
    url: `${baseURL}public/user/refresh`,
    headers: {
      'content-type': 'application/json',
      CSN: '100000000000000',
      CTY: 'B',
      CVS: '3.10.0',
      Authorization: `Bearer ${refreshToken}`
    }
  })
    .then((response) => {
      if (response.data.error != null) {
        cookie.remove('accessToken')
        cookie.remove('refreshToken')
        cookie.remove('BrefreshToken')
        sessionStorage.clear()
        window.location.assign('/')
        throw response.data.error
      }
      // sessionStorage.setItem('accessToken', response.data.object.accessToken);

      // sessionStorage.setItem('BaccessToken', response.data.object.accessToken);

      // sessionStorage.setItem('refreshToken', response.data.object.refreshToken);
      // sessionStorage.setItem('BrefreshToken', response.data.object.refreshToken);
      const expDate = new Date()
      expDate.setTime(expDate.getTime() + 30 * 30 * 30 * 60 * 1000)
      // cookie.save('accessToken', response.data.object.accessToken, { path: '/', expires: expDate });
      // cookie.save('BaccessToken', response.data.object.accessToken, { path: '/', expires: expDate });
      createAccess(response.data.object.accessToken)

      createAccess(response.data.object.refreshToken)

      return response.data.object.accessToken
    })
    .catch((error) => {
      console.log(error)
    })
}

instance.interceptors.request.use(
  (config) => {
    var token = loadAccessToken()
    var refreshToken = loadRefreshToken()
    config.headers['Content-Type'] = 'application/json'
    config.headers.CSN = '100000000000000'
    config.headers.CTY = 'B'
    config.headers.CVS = '3.10.0'
    config.headers.Authorization = `Bearer ${token}`
    return config
  },
  (error) => Promise.reject(error)
)

instance.interceptors.response.use(
  (response) => {
    if (response.data.error === null) {
      return response
    }
    const originalRequest = response.config
    switch (response.data.error) {
      case 'EMPTY_RESULTS':
        message.error(response.data.description + ' کد خطا : ' + response.data.errorCode)
        break
      case 'SERVER_ERROR':
      case 'REQUEST_EXPIRED':
      case 'REQUIRED_FIELDS_NOT_SET':
      case 'INVALID_DATA_TYPE':
      case 'DATA_NOT_FOUND':
      case 'DATA_ALREADY_EXIST':
      case 'UPLOADED_FILE_CORRUPTED':
      case 'EMAIL_ADDRESS_NOT_VALID':
      case 'EMAIL_SEND_FAILED':
      case 'INVALID_VALIDATION_CODE':
      case 'VALIDATION_CODE_EXPIRED':
      case 'USERNAME_ALREADY_EXIST':
      case 'USERNAME_PASSWORD_NOT_MATCH':
      case 'ILLEGAL_REQUEST':
        message.error(response.data.description + ' کد خطا : ' + response.data.errorCode)
        break
      default:
        break
    }
    if (response.data.error === 'ACCESS_DENIED') {
      message.error(response.data.description, 2000)
      setTimeout(() => {
        cookie.remove('accessToken')
        cookie.remove('BaccessToken')
        cookie.remove('refreshToken')
        cookie.remove('BrefreshToken')
        removeCookie()
        sessionStorage.clear()
        window.location.assign('/')
      }, 2000)
    }
    if (
      response.data.error === 'LOGICAL_UN_AUTHORIZED' ||
      response.data.error === 'TOKEN_VERIFICATION_INVALID_TYPE' ||
      response.data.error === 'INVALID_TOKEN_HEADER' ||
      response.data.error === 'INVALID_CLIENT_SERIAL_NUMBER' ||
      response.data.error === 'INVALID_CLIENT_TYPE' ||
      response.data.error === 'USER_NOT_FOUND'
    ) {
      message.error(response.data.description + ' کد خطا : ' + response.data.errorCode)
      // ui error
    }
    if (response.data.error === 'TOKEN_VERIFICATION_EXPIRED') {
      // message.error('مدت زمان استفاده از سیستم به پایان رسید.لطفا صبر کنید', 2000);
      if (isExpired(true)) {
        const refreshToken = cookie.load('refreshToken')
        if (!isRefreshing) {
          isRefreshing = true
          resetToken(refreshToken)
            .then((newToken) => {
              isRefreshing = false
              onRefreshed(newToken)
              const retryOriginalRequest = new Promise((resolve, reject) => {
                subscribeTokenRefresh((token) => {
                  originalRequest.headers.Authorization = `Bearer ${token}`
                  resolve(axios(originalRequest))
                })
              })
              return retryOriginalRequest
            })
            .catch((e) => {
              console.error(e)
            })
        }
      }
    }
    if (response.data.error === 'TOKEN_VERIFICATION_FAILED') {
      cookie.remove('accessToken')
      cookie.remove('BaccessToken')
      cookie.remove('refreshToken')
      cookie.remove('BrefreshToken')
      removeCookie()
      sessionStorage.clear()
      window.location.assign('/')
    }
    if (response.data.error === 'USER_ALREADY_LOGGED_IN') {
      // mobile: خروج از دیگران
    }
    if (
      response.data.error === 'USER_BLOCKED' ||
      response.data.error === 'USER_NOT_CONFIRM' ||
      response.data.error === 'USER_NOT_LOGIN' ||
      response.data.error === 'USER_NOT_ACTIVE'
    ) {
      message.error(response.data.description)
      setTimeout(() => {
        cookie.remove('accessToken')
        cookie.remove('BaccessToken')
        cookie.remove('BaccessToken')
        cookie.remove('refreshToken')
        removeCookie()
        sessionStorage.clear()
        window.location.assign('/')
      }, 1000)
      //  تماس با ائراتور
    }
    return response
  },
  (error) => {
    message.error('خطای سرور - لطفا با ادمین سرور تماس بگیرید')
    // return Promise.reject(error);
  }
)
function subscribeTokenRefresh(cb) {
  refreshSubscribers.push(cb)
}
function onRefreshed(token) {
  refreshSubscribers.map((cb) => cb(token))
  refreshSubscribers = []
}
export default instance
